import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlycaUiBannerGenericComponent } from '../banner-generic.component';

@Component({
  selector: 'plyca-ui-banner-generic-demo',
  templateUrl: './banner-generic-demo.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiBannerGenericComponent]
})
export class PlycaUiBannerGenericDemoComponent {
  public onClickClose(): void {
    console.error('Test');
  }
}
